import {Action} from 'redux';
import {
  WS_CONNECTED_ELSEWHERE,
  WS_WAITING_FOR_PEER,
  WS_CURRENT_STATE,
  WS_END,
} from '../web-socket/constants';

export type SessionRouterPage = 'loading' | 'waiting' | 'session' | 'connected-elsewhere' | 'end';
export type SessionEndTrigger = 'user' | 'peer' | 'timeout';
export type SessionType = 'practice' | 'invite-based-session';

export interface ISessionRouterAction extends Action {
  payload?: any;
}

export interface ISessionRouterState {
  page: SessionRouterPage;
  sessionType: SessionType;
  firstName: string;
  interviewStartTime: number;
  minutesBeforeRematch: number;
  redirectUrl: string;
  endReason: string;
  endTriggeredBy: SessionEndTrigger;
}

export const initialState: ISessionRouterState = {
  page: 'loading',
  sessionType: 'practice',
  firstName: '',
  interviewStartTime: 0,
  minutesBeforeRematch: 0,
  redirectUrl: '',
  endReason: '',
  endTriggeredBy: null,
};

export default function sessionRouterReducer(
  state: ISessionRouterState = initialState,
  action: ISessionRouterAction,
): ISessionRouterState {
  switch (action.type) {
    case WS_CONNECTED_ELSEWHERE:
      return {...state, page: 'connected-elsewhere'};

    case WS_WAITING_FOR_PEER:
      return {
        ...state,
        page: 'waiting',
        interviewStartTime: action.payload.interviewStartTime,
        minutesBeforeRematch: action.payload.minutesBeforeRematch,
      };

    case WS_CURRENT_STATE:
      return {...state, page: 'session'};

    case WS_END:
      return {
        ...state,
        page: 'end',
        firstName: action.payload.firstName,
        redirectUrl: action.payload.redirectUrl,
        interviewStartTime: action.payload.interviewStartTime,
        endTriggeredBy: action.payload.trigger,
        endReason: action.payload.reason,
      };

    default:
      return state;
  }
}
